import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { Store } from '../models/Store';

interface StoreListItemProps {
  store: Store;
}

const StoreListItem: React.FC<StoreListItemProps> = ({
  store,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + (store.jan || "")}
    >
      <IonItem>
        <IonLabel>
          <h3 style={{ fontSize: '20px' }}>
            商品コード : {(store.jan || "") && (store.original_num || "") ? `${store.jan} - ${store.original_num}` : (store.jan || "") + (store.original_num || "")}
          </h3>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            数量 : {store.quantity},
            RACK_NUM : {store.rack_num}
          </p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(StoreListItem);
